<div class="container">
    <div class="left-image">
      <img alt="workinsync" src="../../../../../../assets/left.svg" />
    </div>
    <div class="content">
      <div class="logo">
        <img style="padding-right: 20px" alt="workinsync" class="mr-md" src="../../../../../../assets/mis.svg" />
        <img style="padding-left: 20px" alt="workinsync" class="mr-md" src="../../../../../../assets/WIS-full.svg" />
      </div>
      <div class="main">
        <span class="label"> No Access </span>
        <p>
            You don't have access to this portal, please write to
            <a href="mailto:cs-driverexp@moveinsync.com">cs-driverexp@moveinsync.com</a>
            or
            <a href="mailto:realtime-devs@moveinsync.com">realtime-devs@moveinsync.com</a>
            for access.
        </p>
        <div (click)="goBack()" class="google-sign-in" role="button" tabindex="0">
          Try Again
        </div>
        <div class="seprater">
          <span class="line"></span>
          <!-- <span class="text">OR</span> -->
          <span class="line"></span>
        </div>
      </div>
  
      <div class="right-image">
        <img src="../../../../../../assets/right.svg" />
      </div>
    </div>
  </div>
  